<!--
 * @Author: Y.SY
 * @Date: 2020-2-22
 * @LastEditors  : Y.SY
 * @Description: 我的订单详情头部进度条节点
 * @Remarks:
 -->
<template>
  <div class="od-node">
    <img v-if="nodeType === 1" src="~@/assets/image/order_status_1.png" />
    <span v-if="nodeType === 1">提交订单</span>

    <img v-if="nodeType === 2 && !selectable" src="~@/assets/image/order_status_2_un.png" />
    <img v-if="nodeType === 2 && selectable" src="~@/assets/image/order_status_2_se.png" />
    <span v-if="nodeType === 2" :style="`color: ${selectable ? '#31A826' : '#999999'}`">支付完成</span>

    <img v-if="nodeType === 3 && !selectable" src="~@/assets/image/order_status_3_un.png" />
    <img v-if="nodeType === 3 && selectable" src="~@/assets/image/order_status_3_se.png" />
    <span v-if="nodeType === 3" :style="`color: ${selectable ? '#31A826' : '#999999'}`">处理完成</span>

    <img v-if="nodeType === 4 && !selectable" src="~@/assets/image/order_status_4_un.png" />
    <img v-if="nodeType === 4 && selectable" src="~@/assets/image/order_status_4_se.png" />
    <span v-if="nodeType === 4" :style="`color: ${selectable ? '#31A826' : '#999999'}`">订单完成</span>
  </div>
</template>
<script>
export default {
  props: {
    nodeType: {
      type: Number,
      default: 0
    },
    selectable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {

    }
  },
  computed: {

  },
  created () {

  },
  mounted () {

  },
  activated () {

  },
  deactivated () {

  },
  watch: {

  },
  methods: {
    operation () {

    }
  },
  components: {

  }
}
</script>

<style lang="stylus">
  .od-node
    display flex
    flex-direction column
    align-items center
    justify-content center
    img
      margin-bottom 12px
      width 25px
      height 25px
    span
      color #999999
      font-size 16px
</style>
